<template>
    <div>
      未能正常定位到所请求的资源
      <a href="/" target="_self">点击这里跳转</a>
    </div>
</template>

<script>
    export default {
        name: ""
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/error404.vue